import hateoas from 'viralstyle-ui/src/hateoas';

export const getCampaignDetails = async ({ rootState, getters, state, dispatch, commit }) => {
  let publicName = rootState.route.params.publicName,
    campaignSlug = rootState.route.params.campaignSlug;

  if (rootState.isWhitelabel) {
    publicName = rootState.domainConfig.public_name;
  }

  let response = await dispatch('get', hateoas.url('get_campaign', { publicName, slug: campaignSlug }));

  commit('updateState', {
    object: state,
    property: 'campaign',
    value: response.data,
  });

  return response;
};

export const optOutAbandonedCart = async ({ dispatch }, cartId) => {
  let response = await dispatch('put', { apiUrl: hateoas.url('optout_cart_email', { cartId }) });

  return response;
};